// extracted by mini-css-extract-plugin
export var drawerContent = "_3e-0";
export var valueBlock = "_3e-1";
export var valueBlockFrom = "_3e-2 _3e-1";
export var valueBlockTo = "_3e-3 _3e-1";